<template>
  <section class="cp" :class="{ 'cp-acento': acento }">
    <div class="cp-h">
      <h2>{{ titulo }}</h2>
      <span v-if="pista" class="cp-hint">{{ pista }}</span>
      <slot name="accion"></slot>
    </div>
    <div class="cp-b"><slot></slot></div>
  </section>
</template>

<script>
export default {
  props: {
    titulo: { type: String, default: '' },
    pista: { type: String, default: '' },
    // El borde de color de la maqueta para el bloque que viene de fuera (la línea de oferta).
    acento: { type: Boolean, default: false }
  }
};
</script>

<style scoped>
.cp{background:var(--surface);border:1px solid var(--line);border-radius:var(--r);min-width:0}
.cp-acento{border-color:var(--accent)}
.cp-h{display:flex;align-items:baseline;justify-content:space-between;flex-wrap:wrap;gap:4px 10px;padding:12px 16px 0}
.cp-h h2{font-family:var(--f-display);font-size:14px;font-weight:600;margin:0;letter-spacing:.01em;color:var(--fg)}
.cp-hint{font-size:12px;color:var(--muted)}
.cp-b{padding:12px 16px 16px}
</style>
